// extracted by mini-css-extract-plugin
export default {"tooltip":"wn-z","sharingV2":"xn-z","sharingIconsV2":"yn-z","links":"zn-z","link":"An-z","facebookV2":"Bn-z","twitterV2":"Cn-z","pinterestV2":"Dn-z"};